import { KText } from '@/ui-library/components/text';
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Icon,
  Flex,
} from '@chakra-ui/react';
import { ChevronDownIcon } from '@heroicons/react/solid';
import { CheckIcon } from '@heroicons/react/solid';
import { useKFlags } from '@/hooks/use-k-flags';

export const MenuSelect = ({
  icon = null,
  prefix = null,
  options = [],
  selected = {},
  onSelect = () => {},
  styles = undefined,
  ...props
}) => {
  const { feReportsV3 } = useKFlags();
  return (
    <Menu>
      <MenuButton
        as={Button}
        height={feReportsV3 ? '32px' : '40px'}
        variant="secondary"
        border="1px solid"
        borderColor="border-color"
        rightIcon={
          <Icon as={ChevronDownIcon} w="16px" h="16px" color="secondary-700" />
        }
        _hover={{ bg: 'secondary-25' }}
        _active={{ bg: 'secondary-25' }}
        {...props}
      >
        <Flex alignItems="center">
          {icon && <Icon as={icon} mr="4px" color="secondary-700" />}
          {prefix && (
            <KText mr="4px" {...(feReportsV3 && { fontWeight: '550px' })}>
              {prefix}:
            </KText>
          )}
          <KText
            {...(feReportsV3
              ? {
                  fontWeight: '550px',
                  color: 'secondary-900',
                }
              : {
                  size: 'sm-semi-bold',
                })}
          >
            {selected?.label}
          </KText>
        </Flex>
      </MenuButton>
      <MenuList {...(styles?.menuList ?? {})}>
        {options?.map((option) => {
          const selectedOption = option?.id === selected?.id;
          return (
            <MenuItem
              key={option?.id}
              onClick={() => {
                onSelect(option);
              }}
            >
              <KText flex="1">{option.label}</KText>
              {selectedOption && <Icon as={CheckIcon} color="primary-500" />}
            </MenuItem>
          );
        })}
      </MenuList>
    </Menu>
  );
};
